var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opening__container splitting",attrs:{"data-splitting":"chars"}},[_c('div',{staticClass:"opening__title"},[_vm._v("HENFORD")])])
}]

export { render, staticRenderFns }